/** Deep-clone for journey / quote payloads (drops functions, safe for JSON). */
export const cloneForJourney = (value) => {
  if (value == null) return value;
  try {
    return JSON.parse(JSON.stringify(value));
  } catch {
    return null;
  }
};
